import angular from "angular";
import { AddBankAccountComponent } from "./add-bank-account.component";
import { ChangeDirectDepositComponent } from "./change-direct-deposit.component";
import { EditBankAccountsComponent } from "./edit-bank-accounts.component";

export const BankAccountModule = angular
    .module("apex.mainApp.roster.bankAccount", [])
    .component("apexAddBankAccount", AddBankAccountComponent)
    .component("apexChangeDirectDeposit", ChangeDirectDepositComponent)
    .component("apexEditBankAccounts", EditBankAccountsComponent)
    .name;
